import { render, staticRenderFns } from "./EditWithdrawKkp.vue?vue&type=template&id=ca2d1d7e"
import script from "./EditWithdrawKkp.vue?vue&type=script&lang=js"
export * from "./EditWithdrawKkp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports